<template>
  <div class="btn-bottom3" @click="click">
    <div class="inner-box" style="margin-bottom: 12px;">
      <span class="bold">피보험자</span>
      <span class="weak">자필서명</span>
    </div>
    <div class="inner-box">
      <span class="bold">계약자</span>
      <span class="weak">자필서명</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    btnTitle: String,
    btnTitle2: String,
    btnWeakTitle: String,
    disabled: Boolean,
    click: Function,
    click2: Function
  }
}
</script>

<style lang="scss">
  .btn-bottom3 {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: sticky;
    width: 100%;
    height: 150px;
    left: 0px;
    bottom: 0px;
    padding: 21px 20px 21px 20px;
    background: #0B2673;

    font-family: NanumSquareOTF;
    font-style: normal;
    font-size: 16px;
    line-height: 28px;
    /* identical to box height, or 175% */
    letter-spacing: -0.32px;

    color: #FEFEFE;
    
    .inner-box {
      background: #C94D4D;
      width: 100%;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      .bold {
        font-weight: 800;
        margin-right: 4px;
      }
      .weak { 
        font-weight: 100;
      }
    }
  }
</style>